// extracted by mini-css-extract-plugin
module.exports = {"uploadedFileIcon":"FileIcon_uploadedFileIcon__2PgCo","uploadedFileExtension":"FileIcon_uploadedFileExtension__3QLaU"};